import React, { useState } from "react";
import HeaderLayout from "Components/LoggedInLayout/HeaderLayout";
import DataToolkitNav from "Pages/Dashboard/data-toolkit/DataToolkitNav";
import DataToolkitRouting from "Pages/Dashboard/data-toolkit/DataToolkitRouting";
import "Pages/Dashboard/data-toolkit/dataToolkit.scss";

const defaultBreadcrumb = [{ name: "Data Toolkit", link: "/data-toolkit" }];

const DataToolkitModule = () => {
  const [breadcrumbArr] = useState([...defaultBreadcrumb]);

  return (
    <div className="dataToolkitPage pageClass">
      <HeaderLayout className="dataToolkit" breadcrumbArr={breadcrumbArr} />
      <div className="dtLayout">
        <DataToolkitNav />
        <div className="dtMain">
          <DataToolkitRouting />
        </div>
      </div>
    </div>
  );
};

export default DataToolkitModule;
export { DataToolkitModule };
